import { checkAnswers } from "../../list/logic/answers";
import { TestableSentence } from "../../wordfill/types";
import { Answer, Content, Score } from "../types";

export function markAnswer(content: Content, answer: Answer): Score {
  const { values, numRequiredAnswers } = content;
  const hits = values.map(
    (value: any) =>
      !!answer &&
      answer.some(wordAnswer =>
        checkAnswers(value as unknown as TestableSentence, wordAnswer)
      )
  );
  const numHits = hits.filter((item: any) => !!item).length;
  const score =
    numHits === 0
      ? 0
      : numHits > numRequiredAnswers
        ? 1
        : Number((numHits / numRequiredAnswers).toFixed(4));

  return {
    score,
    hits,
    correctOrderedValues: getCorrectOrderedValues(values, answer),
    incorrectValues: getIncorrectValues(values, hits)
  };
}

function getCorrectOrderedValues(values: any, answer: any) {
  if (!answer) {
    return [];
  }

  const correctOrderedValues: any[] = [];

  for (let wordAnswer of answer) {
    for (let value of values) {
      if (
        checkAnswers(value, wordAnswer) &&
        !correctOrderedValues.find(
          val => JSON.stringify(val) === JSON.stringify(value)
        )
      ) {
        correctOrderedValues.push(value);
        continue;
      }
    }
  }

  return correctOrderedValues;
}

function getIncorrectValues(values: any[], hits: any) {
  return values.filter((val: any, index: any) => !hits[index]);
}
